import { useContext, useEffect, useState } from 'react';
import { MovableTypePrintingContext } from './MovableTypePrintingProvider';

interface GamePrintingPrintResultProps {
  onEnd: ()=> void,
}
export default function GamePrintingPrintResult(props: GamePrintingPrintResultProps) {
  const { onEnd } = props;
  const { answers, total } = useContext(MovableTypePrintingContext);
  const [squaresByColumn, setSquaresByColumn] = useState([[]]);
  const [fliped, setFliped] = useState<'' | 'hide' | 'slide-in' | 'flip-in'>('');
  const [brushUsed, setBrushUsed] = useState<'' | 'used'>('');
  const [tools, setTools] = useState<'' | 'used'>('');
  const theAnswer = answers.map(a => a?.text).join('');

  useEffect(() => {
    // console.log(total);
    setSquaresByColumn(Array(2).fill(Array(Math.ceil(total / 2)).fill(null)));

    let brushUsed = setTimeout(() => setBrushUsed('used'), 1000);
    let slideIn = setTimeout(() => setFliped('slide-in'), 2000);
    let tools = setTimeout(() => setTools('used'), 3000);
    let flipIn = setTimeout(() => setFliped('flip-in'), 4000);
    let end = setTimeout(() => {
      // console.log(1234);
      onEnd()
    }, 4800);

    return () => {
      clearTimeout(brushUsed);
      clearTimeout(slideIn);
      clearTimeout(tools);
      clearTimeout(flipIn);
      clearTimeout(end);
    }
  }, [total, onEnd]);

  return (
    <>
      <div className={`game-printing-printed game-printing-printed-2-${Math.floor(total / 2)} game-printing-printed-${fliped}`}>
        {/* {theText.split('').map(x => <div className="game-printing-printed-character">{x}</div>)} */}
        {squaresByColumn.map((squares, columnIndex) => <div key={columnIndex} className={`game-printing-printed-column`}>
          {squares.map((_, i) => <div key={i} className={`game-printing-printed-character ${theAnswer[(1 - columnIndex) * Math.ceil(total / 2) + i].match(/^[\u0000-\u007f]*$/) ? 'en' : 'zh'}`}><div>{theAnswer[(1 - columnIndex) * Math.ceil(total / 2) + i]}</div></div>)}
        </div>)}
        <div className="game-printing-printed-label">玩家答案:</div>
      </div>

      <div className={`game-printing-print-tools-unknown game-printing-print-tools-unknown-${tools}`}></div>

      <div className="game-printing-print-ink-slab"></div>
      <div className={`game-printing-print-ink-brush game-printing-print-ink-brush-${brushUsed}`}></div>
    </>
  )
};
